import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TesteService } from 'src/app/services/teste.service';


@Component({
  selector: 'app-comunicacao',
  templateUrl: './comunicacao.component.html',
  styleUrls: ['./comunicacao.component.scss']
})
export class ComunicacaoComponent implements OnInit {
  inscricao: any;


  constructor( private testeService: TesteService, private router: Router) { }

  ngOnInit(): void {
    this.inscricao = this.testeService.pub_inscricao;
  }

  goTo() {
   /// dispara email this.solicitacao.email
   ///this.testeService.EnviarEmail('jpacheco@inca.gov.br','jpacheco@inca.gov.br','TAXIGOV', 'teste de envio taxi-gov').subscribe(resp => {
   /// console.log('Resposta', resp);
   ///}, error => console.error('Erro ao tentar gravar', error));

   /// navega para a lista
   this.router.navigate(['/administra'])
  }


}
